<template>
  <div class="detailed-card">
    <h2 class="title --center --smaller">{{ content.name }}</h2>
    <h3 class="detailed-card__type" v-if="type">{{ type }}</h3>
    <div class="detailed-card__content">
      <Image
        v-if="content.image"
        :source="content.image"
        :class="['detailed-card__image', { '--service': isService }]"
      />
      <div>
        <RawHtml :html="content.description" class="detailed-card__description" />
        <RawHtml v-if="content.notes" :html="content.notes" class="detailed-card__notes" />
        <Button
          v-if="content.reservation_link"
          :link="content.reservation_link"
          :label="$t('global.reserve')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import Button from '@/components/small/Button.vue'

export default {
  name: 'DetailedCard',
  components: { Button, Image, RawHtml },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isService() {
      return this.content.type ? this.content.type === 'service' : false
    },
    type() {
      switch (this.content.type) {
        case 'package':
          return this.$t(`packages.${this.content.is_promo ? 'offer' : 'package'}`)
        case 'service':
          return this.content.subtitle
        default:
          return null
      }
    },
  },
}
</script>
